// SPDX-License-Identifier: AGPL-3.0-or-later
export const API_CODE_VERSION = 1;
export const DEFAULT_API_VERSION = 1;
export const FLUXERBOT_ID = '0';
export const ME = '@me';
export const FAVORITES_GUILD_ID = '@favorites';
export const DEFAULT_ACCENT_COLOR = '#4641D9';
export const CANARY_TESTERS_GUILD_ID = '1427764661718740994';
export const CANARY_TESTER_MIN_ACCOUNT_AGE_MS = 30 * 60 * 1000;
